import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Box, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const CustomAccordion = ({ summary, details }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleToggle = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion
      expanded={expanded}
      sx={{
        boxShadow: "none",
        borderRadius: "15px",
        bgcolor: "#F4F4F4",
        width: "100%",
        "&::before": { backgroundColor: "transparent" },
      }}
    >
      <AccordionSummary sx={{ position: "relative" }}>
        <Box sx={{ width: "100%", position: "relative" }}>
          {summary}


          <IconButton
            onClick={handleToggle}
            sx={{ position: "absolute", bottom: 0, right: 0 }}
          >
            {!expanded ? <ExpandMoreIcon fontSize="medium" /> : <ExpandLessIcon fontSize="medium" />}
          </IconButton>

        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ px: "2%", position: "relative" }}>
        {details}


      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
